import { createSlice } from "@reduxjs/toolkit";
import { set } from "date-fns";

const drmUpdateTableDataSlice = createSlice({
  name: "updateDrmTable",
  initialState: {
    bidMaintenanceDetails: [],
    isLoading: false,
    errorMessage: undefined,
    successMessage: undefined,
  },
  reducers: {
    setUpdateDrmTableData: (state) => {
      state.isLoading = true;
    },
    setUpdateDrmTableDataSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    setUpdateDrmTableDataFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload
    },
    setResetUpdateDrmTableDataState: (state) => {
      state.isLoading = false;
      state.errorMessage = undefined;
      state.successMessage = undefined;
    }
  },
});

export const {
  setUpdateDrmTableData,
  setUpdateDrmTableDataSuccess,
  setUpdateDrmTableDataFailure,
  setResetUpdateDrmTableDataState
} = drmUpdateTableDataSlice.actions;

export default drmUpdateTableDataSlice.reducer;
